import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  display: flex; align-items: center; justify-content: center; min-height: 200px;
`;

const Spinner = styled.div`
  width: 40px; height: 40px; border: 4px solid ${props => props.theme.colors.grayLight}; border-top-color: ${props => props.theme.colors.secondary}; border-radius: 50%; animation: ${spin} 1s linear infinite;
`;

const LoadingSpinner = () => (
  <Wrapper>
    <Spinner />
  </Wrapper>
);

export default LoadingSpinner;


